import {
  APP_INITIALIZER,
  NgModule,
  Optional,
  provideExperimentalZonelessChangeDetection,
  SkipSelf,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { TranslocoRootModule } from './core/transloco/transloco-root.module';
import { environment } from '../environments/environment';
import { ThemeService } from './core/services/theme.service';
import { LoaderService } from './core/services/loader.service';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { AppInitService } from './core/services/app-init.service';
import { HttpErrorInterceptor } from './core/interceptors/http-errors.interceptor';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { MatIconRegistry } from '@angular/material/icon';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { provideHotToastConfig } from '@ngneat/hot-toast';
import { TranslocoService } from '@jsverse/transloco';

export function appInit(appInitService: AppInitService) {
  return () => appInitService.init();
}

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    TranslocoRootModule,
    RouterModule.forRoot([], {
      scrollPositionRestoration: 'top',
      enableTracing: false,
      preloadingStrategy: PreloadAllModules,
    }),
    environment.production
      ? []
      : AkitaNgDevtools.forRoot({
          shallow: true,
          maxAge: 100,
          actionsBlacklist: [],
        }),
  ],
  providers: [
    provideExperimentalZonelessChangeDetection(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: false,
        minWidth: 300,
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [AppInitService, TranslocoService],
      multi: true,
    },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideHotToastConfig({
      reverseOrder: false,
      dismissible: true,
      autoClose: true,
    }),
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
  ],
})
export class AppModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
    private themeService: ThemeService,
    private loaderService: LoaderService,
    iconRegistry: MatIconRegistry,
  ) {
    if (parentModule) {
      throw new Error('AppModule is already loaded. Import only in AppModule');
    }
    this.initializeCoreState();
    // iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

  private initializeCoreState() {
    this.themeService.init();
    this.loaderService.init();
  }
}
